import Image from 'next/image';
import { awsImage } from '@firsttable/functions';
import { cn } from '@discover-lib/utils';

export type RestaurantCardSlideProps = {
  imageSource: string;
  title?: string | null;
  isActive: boolean;
  isPriority?: boolean;
  onLoad: (imageSource: string) => void;
};

function toCardImageSrc(imageSource: string) {
  return imageSource.startsWith('/images/') ? imageSource : awsImage(imageSource, 220, 220);
}

export default function RestaurantCardSlide({
  imageSource,
  title,
  isActive,
  isPriority,
  onLoad,
}: RestaurantCardSlideProps) {
  return (
    <Image
      src={toCardImageSrc(imageSource)}
      alt={`Photo of ${title || 'a restaurant'}`}
      fill
      sizes="(max-width: 1024px) 24vw, 220px"
      priority={isPriority}
      quality={60}
      className={cn(
        'rounded object-cover transition-opacity duration-700',
        isActive ? 'opacity-100' : 'opacity-0'
      )}
      onLoad={() => {
        onLoad(imageSource);
      }}
    />
  );
}
